import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../services/common/common.service';
import * as moment from 'moment';

interface FormValues {
  [key: string]: any;
  fromDate?: string;
  toDate?: string;
}

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})

export class FilterComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() openFilterModel: boolean = false;
  @Input() formFields: any = [];
  @Output() formData: EventEmitter<any> = new EventEmitter<any>();
  @Input() prefilldata: any
  @Output() selectedValue: any = new EventEmitter();


  currentDate: any;
  filterForm!: FormGroup;
  minToDate: any

  constructor(
    private _formBuilder: FormBuilder,
    private commonService: CommonService
   ) {}

  ngOnInit(): void {
    this.currentDate = moment().format();
    // console.log('Form Field Arr: ', this.formFields);

    this.formFields?.forEach((element: any) => {
      if (element?.apiConfig?.initialData) {
        this.loadFieldData(element.name);
      }
    });
  }

  ngAfterViewInit(): void {
    this.prefilldata = [];
    // console.log('NgAfterViewInit PrfilledData: ',this.prefilldata);
    this.prefilldata?.forEach((element: any) => {
      this.filterForm.get(element?.control)?.patchValue(+element?.value);
      this.selectedFormValue(element, element?.control)
    });
    // console.log('FilterForm: ', this.filterForm);

  }

  onFromDateChange(event: any) {
    this.minToDate = event.value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log('Changes: ', changes);

    this.prefilldata = [];
    this.currentDate = moment().format();
    this.createFilterForm();

    // console.log('Form Field Arr: ', this.formFields);

    if(changes?.prefilldata?.currentValue) {
      this.prefilldata = changes?.prefilldata?.currentValue;
      // console.log('PreFillData: ', this.prefilldata);

      this.prefilldata?.forEach((element: any) => {
        this.filterForm?.get(element?.control)?.patchValue(+element?.value);
      this.selectedFormValue(element, element?.control)
      });
    }

    this.formFields?.forEach((element: any) => {
      if (element?.apiConfig?.initialData) {
        this.loadFieldData(element.name);
      }
    });

    // console.log('Filter Form Check: ',this.filterForm)

  }

  loadFieldData(key: string, selectedValue?: any) {

    const element = this.formFields?.find((element: any) => element.name === key);

    if (key == 'villageId') {
      element.options = element?.apiConfig?.setOptions(selectedValue);
      return;
    }
    this.commonService.getApiData(`${element?.['apiConfig']?.endPoint}${selectedValue ? selectedValue : ''}`).subscribe((res: any) => {
      // console.log('Response Api: ', res);
      element.options = element?.apiConfig?.setOptions(res);
    });
  }

  createFilterForm() {
    const formGroup = this.formFields?.reduce((group: any, field: any) => {
      group[field.name] = field.name === 'financialYear' || field.name === 'finYear'
        ? ['', Validators.required]
        : [''];
      return group;
    }, {});

    this.filterForm = this._formBuilder.group(formGroup);
  }

  reset() {
    this.filterForm.reset();
    this.submitForm( 'reset' );
    this.minToDate = ''
    this.sendData( 'reset' );
  }

  sendData(type: string) {
    let data = {}
    if (type == 'reset') {
       data = {
        reset: true,
       reportType: 1,
     }
    } else {
      data = {
        reset: false,
       reportType: 1,
     }
    }

    this.commonService.changeData(data);
  }

  submitForm(type?:any) {
    const formValues = this.filterForm.value;
    if (type != 'reset' && this.filterForm.invalid) {
      // console.log('form is invalid')
      return
    }
    let filledFormValues: FormValues = {};

    for (const [key, value] of Object.entries(formValues)) {
      if (value !== null && value !== '') {
        filledFormValues[key] = value;
      }
    }

    if (filledFormValues.fromDate) {
      filledFormValues.fromDate = moment(filledFormValues.fromDate).format('YYYY-MM-DD');
    }

    if (filledFormValues.toDate) {
      filledFormValues.toDate = moment(filledFormValues.toDate).format('YYYY-MM-DD');
    }

    // console.log('Filled form values: ', filledFormValues);

    if( type == 'reset') {
      this.formData.emit(null)
    } else {
      this.formData.emit(filledFormValues);
      this.sendData( 'submit' )
    }
    this.openFilterModel = false;
  }

  selectedFormValue(event: any, fieldName: string): void {
    // console.log('Selected Value: ', event , 'ControllerName: ', fieldName);


    const selectedValue = event?.value;

    this.selectedValue.emit({
      fieldName: fieldName,
      selectedValue: selectedValue
    })

    let element = this.formFields?.find((element: any) => element.name === fieldName);

    if (fieldName == 'gpId') {
      let villageList = element.options.find((ele: any)=> ele.value == selectedValue)?.villageList;
      this.loadFieldData(element?.apiConfig?.onChange, villageList);
      return;
    }
    if (element?.apiConfig?.onChange) {
      this.loadFieldData(element?.apiConfig?.onChange, selectedValue);
    }
  }

  setFilterModel() {
    this.openFilterModel = !this.openFilterModel;
  }
}
